/**
 * Configuration for Mapbox feature-based composables.
 * Allows generic mapbox utilities to work with any feature type.
 */
export interface MapboxFeatureConfig {
	/** Property key for unique feature identifier in GeoJSON properties */
	idProperty: string

	/** Optional filter IDs that need special handling */
	specialFilterIds?: {
		/** Filter ID for table data markers (gets priority in sorting) */
		tableDataMarkerId?: string
	}
}

/**
 * Default configuration (uses generic property names)
 */
export const DEFAULT_FEATURE_CONFIG: MapboxFeatureConfig = {
	idProperty: 'id',
	specialFilterIds: {}
}
